module.exports = __webpack_public_path__ + "img/central-african-republic.51aa4f0a.svg";